<template>
  <v-line v-for="(cfg, i) in visibleEventLines" :key="i" :config="cfg"></v-line>
</template>

<script setup>

import { computed, inject } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChart = inject('chart')
const mainChartRender = inject('chartRender')
const { currentTime, negativeVisibleTime, positiveVisibleTime, chartWidth } = mainChartRender

const chartRenderStore = useChartRenderStore()

const visibleEventLines = computed(() => {
  return mainChart.orderedEventLines.value.filter(e => e.time >= currentTime.value - negativeVisibleTime.value && e.time <= currentTime.value + positiveVisibleTime.value)
    .map(e => {
      const p = chartRenderStore.timeToPixel(e.time)
      return {
        points: [0, p, chartWidth.value, p],
        stroke: e.colour ?? 'blue',
        strokeWidth: e.thickness ?? 4
      }
    })
})

</script>